import axios from "axios";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.interceptors.request.use((req) => {
    if (localStorage.getItem("auth_token")) {
        req.headers.Authorization = `Bearer ${localStorage.getItem(
            "auth_token"
        )}`;
    }

    return req;
});

//users
export const getRequest = () => API.get("/users");
export const getListRequest = () => API.get("/users/list");
export const getOneRequest = (id) => API.get(`/users/${id}`);
export const createRequest = (newState) => API.post(`/users`, newState);
export const updateRequest = (id, updatedState) =>
    API.patch(`/users/${id}`, updatedState);
export const editProfileRequest = (updatedState) =>
    API.patch(`/users/profile/edit`, updatedState);
export const passwordChangeRequest = (updatedState) =>
    API.patch(`/users/profile/passwordChange`, updatedState);
export const changeLanguageRequest = (lang) =>
    API.patch(`/users/profile/changeLanguage`, { lang });
export const emailResetRequest = (formData) =>
    API.post(`/users/profile/password/resetEmail/`, formData);
export const passwordResetRequest = (userId, token, formData) =>
    API.post(
        `/users/profile/password/resetConfirm/${userId}/${token}`,
        formData
    );
export const passwordAdminResetRequest = (formData) =>
    API.post(`/users/profile/password/resetAdminConfirm/`, formData);
export const deleteRequest = (id) => API.delete(`/users/${id}`);
export const deleteMultiRequest = (id) => API.delete(`/users/m/${id}`);
